import {
  GET_KB_MESSAGES_REQUESTED,
  GET_KB_MESSAGES_SUCCESS,
  GET_KB_MESSAGES_FAILED,
  CREATE_KB_MESSAGES_REQUESTED,
  CREATE_KB_MESSAGES_SUCCESS,
  CREATE_KB_MESSAGES_FAILED,
  CLEAR_KB_MESSAGES_ERROR
} from '../actions/actionTypes'
import _cloneDeep from 'lodash/cloneDeep'

const initialState = {
  messages: [],
  createdFlag: 1,
  totalElements: 0,
  isLoading: false,
  commonError: '',
  message: {},
  isLoadingDetails: false,

}

const kbReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_KB_MESSAGES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_KB_MESSAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        messages: action.payload.messages,
        totalElements: action.payload.totalElements
      }
    case GET_KB_MESSAGES_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case CLEAR_KB_MESSAGES_ERROR:
      return {
        ...state,
        commonError: ''
      }
    case CREATE_KB_MESSAGES_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case CREATE_KB_MESSAGES_SUCCESS:
      return {
        ...state,
        createdFlag: state.createdFlag * -1,
        isLoading: false
      }
    case CREATE_KB_MESSAGES_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    default:
      return state
  }
}

export default kbReducer
